/**
 * YouLaber 实验员展示元数据派生器（无硬编码字典）
 *
 * device_type / device_name / tags / lab / course_id 全部由 ybg-cc-bridge
 * 的 bridge-config.yaml 上报到 ClawManager，再下发到前端——前端不再维护
 * "课程→图标/简介"的映射表。
 *
 * 教师/管理员需要修改"课程展示信息"时，应去 GVA 教师端或编辑 bridge 配置，
 * 而不是修改本仓库代码。
 *
 * 这里只做两件无业务语义的视觉派生：
 *   1) accent 颜色   —— 由 device_type 字符串哈希到 hsl 色环，保证同 type 同色。
 *   2) icon         —— 统一 🧪（实验试管），不再装饰性区分课程。
 */

function hashHue(s) {
  let h = 0;
  for (let i = 0; i < (s || "").length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h % 360;
}

function accentFromType(deviceType) {
  if (!deviceType) return "#8b949e";
  const hue = hashHue(deviceType);
  return `hsl(${hue}, 60%, 58%)`;
}

export function getDeviceTypeMeta(deviceType) {
  if (!deviceType) {
    return { name: "未知实验员", icon: "🧪", accent: "#8b949e" };
  }
  return {
    name: deviceType,            // 直接用 bridge 上报的中文 device_type
    icon: "🧪",
    accent: accentFromType(deviceType),
  };
}
